<template>
	<div class="nomination_list_box_container">

		<div class="nomination_list_box"
		v-for="contest in contests"
		:key="contest.id"
		>

			<nomination-supercat-contest-box
			:contest="contest"
			:list_type="list_type"
			:supercat_icon="supercat_icon"
			></nomination-supercat-contest-box>

		</div>

	</div>
</template>

<script>
import NominationSupercatContestBox from './nominate_supercat_contest_box.vue';

export default {
	name: 'NominationListBox',
	props: [
		'contests',
		'list_type',
		'supercat_icon'
	],
	data () {
	return {
		
	}
	},
	methods: {
	
	},
	components: {
		NominationSupercatContestBox
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/features/nominate/nominate_list_box.vue